import { useEffect } from "react";

import { useArticleRenderContext } from "~/components/article/article-render/contexts";
import { useContentSchemaRenderLink } from "~/components/schema-render/common/link/hooks";
import { useExperiment, useOptimizelyContext } from "~/lib/optimizely";
import { OptimizelyExperimentIds } from "~/lib/optimizely/consts";

export const useHardLinkABTest = () => {
  const { percentageReached } = useArticleRenderContext();
  const { fireEvent } = useOptimizelyContext();
  const { isExperimentActive, variant } = useExperiment(OptimizelyExperimentIds.HardLink);
  const { ComponentWithExtraProps: LinkWithExtraProps } = useContentSchemaRenderLink({
    forceHideDigitalArchiveLink: variant?.index === 1,
  });

  useEffect(() => {
    if (!isExperimentActive || !percentageReached || ![20, 50, 100].includes(percentageReached))
      return;
    fireEvent?.({
      eventName: `viewed_percentage_${percentageReached}`,
      tags: {
        label: location.href,
      },
    });
  }, [fireEvent, isExperimentActive, percentageReached]);

  return {
    LinkWithExtraProps,
  };
};
